const appSettings = {
  authRoutes: ["/profile", "/crewdocs", "/crewlogs", "/employment", "finance"],
  subscriptionRequiredRoutes: ["/employment"],
  passportPhotoDocId: "9262f04e-c500-48e2-b641-7139856788b9",
  isMobile: Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1,
  isIOS: /\b(iPad|iPhone|iPod)\b/.test(navigator.userAgent) && !window.MSStream,
};

export default appSettings;
